import React from "react";
import * as s from "./MainView.styles";
import Routes from "../Routes";

const MainView = (props) => {
  const { isFullPageLayout } = props;

  return (
    <s.MainViewContainer isFullPageLayout={isFullPageLayout}>
      <Routes />
    </s.MainViewContainer>
  );
};
export default MainView;
